// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".response__date[data-v-2042293e]{color:rgba(7,9,25,.5)}.response__content[data-v-2042293e]{margin-left:56px}.direct-message-block[data-v-2042293e]{border-bottom:2px solid #eeeff8}", ""]);
// Exports
module.exports = exports;
